var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ce',{class:_vm.className,attrs:{"tag":"div","editor-tag":"p","params":[_vm.block, 'value']}})
}
var staticRenderFns = []

export { render, staticRenderFns }